import Bareme from "./utils/bareme";
import { round10 } from "round10";
import getSetting from "./getSetting";
import { ETAT_VS_ETUDE } from "./components/viewer/Viewer";
import { PRESSION_IMMOBILIERE_OPTION } from "./data/pression_immobiliere";

const computationApp = {
    code: "vente-gre-gre-wal",
    name: "Vente de Gré à Gré (Wallonie)",
    mainField: "prix",
    defaultValue: {
        prix: 0,
        droitEnregistrement: 12.5,
        annexe: false,
        pressionImmobiliere: PRESSION_IMMOBILIERE_OPTION[0].value, //Zone à pression Immobilière normale (2018)
        reductionPartielle: false,
        montantAcquereurReduction: 0,
        montantAutreAcquereur: 0,
        abattement: false,
        nombreBiens: 0,
        overrideFraisDivers: false,
        nombreBureauxSupplementaires: 0,
        fraisDivers: 0
    },
    compute: (settings, value) => {
        const bareme = new Bareme("J");
        let honoraire = bareme.compute(value.prix).total;
        const tauxTva = 0.21;
        /*------------------------------------*\
          #Region : wallonie. 🔥🔥
        \*------------------------------------*/

        let droitEnregistrementArray = [];
        let droitEnregistrement = 0;
        let droitEnregistrementLabel = "Droits d'enregistrement";

        /*------------------------------------*\
          #Abattement (20.000€)
        \*------------------------------------*/
        //On crée une copie du prix pour que le -20.000€ ne soit pas enregistré dans la db
        let prixAvecAbattement = value.prix - (value.abattement ? 20000 : 0);
        //On ne veut pas de droits d'enregistrement négatifs
        if (prixAvecAbattement < 0) {
            prixAvecAbattement = 0;
        }
        let abattementLabel = value.abattement ? "(Abattement 20.000€)" : "";
        /*------------------------------------*\
          #Remise sur droits d'enregistrement
        \*------------------------------------*/
        if (value.droitEnregistrement === 6) {
            let limitePressionImmobiliere = value.pressionImmobiliere;
            if (prixAvecAbattement <= limitePressionImmobiliere) {
                droitEnregistrementLabel = `Droits d'enregistrement (6%) ${abattementLabel}`;
                droitEnregistrement = (value.droitEnregistrement / 100) * prixAvecAbattement;
                droitEnregistrement = round10(droitEnregistrement, -2);
                /*------------------------------------*\
                  #Montant minimum
                \*------------------------------------*/
                if (droitEnregistrement < 50) {
                    droitEnregistrement = 50;
                }
                droitEnregistrementArray.push({
                    label: droitEnregistrementLabel,
                    value: droitEnregistrement,
                    etat: true,
                    tva: false
                });
            } else {
                let droitEnregistrementAbatu = (6 / 100) * limitePressionImmobiliere;
                let droitEnregistrementNonAbatu = (12.5 / 100) * (prixAvecAbattement - limitePressionImmobiliere);
                droitEnregistrementAbatu = round10(droitEnregistrementAbatu, -2);
                droitEnregistrementNonAbatu = round10(droitEnregistrementNonAbatu, -2);

                droitEnregistrementArray.push(
                    {
                        label: `Droits d'enregistrement (6%) ${abattementLabel}`,
                        value: droitEnregistrementAbatu,
                        etat: true,
                        tva: false
                    },
                    {
                        label: `Droits d'enregistrement (12,5%) ${abattementLabel}`,
                        value: droitEnregistrementNonAbatu,
                        etat: true,
                        tva: false
                    }
                );
            }
        } else if (value.droitEnregistrement === 5) {
            droitEnregistrementLabel = `Droits d'enregistrement (5%) ${abattementLabel}`;
            droitEnregistrement = (value.droitEnregistrement / 100) * prixAvecAbattement;
            droitEnregistrement = round10(droitEnregistrement, -2);
            /*------------------------------------*\
              #Montant minimum
            \*------------------------------------*/
            if (droitEnregistrement < 50) {
                droitEnregistrement = 50;
            }
            droitEnregistrementArray.push({
                label: droitEnregistrementLabel,
                value: droitEnregistrement,
                etat: true,
                tva: false
            });
        } else if (value.droitEnregistrement === 12.5) {
            droitEnregistrementLabel = `Droits d'enregistrement (12,5%) ${abattementLabel}`;
            droitEnregistrement = (value.droitEnregistrement / 100) * prixAvecAbattement;
            droitEnregistrement = round10(droitEnregistrement, -2);
            /*------------------------------------*\
              #Montant minimum
            \*------------------------------------*/
            if (droitEnregistrement < 50) {
                droitEnregistrement = 50;
            }
            droitEnregistrementArray.push({
                label: droitEnregistrementLabel,
                value: droitEnregistrement,
                etat: true,
                tva: false
            });
        } else {
            throw new Error();
        }
        /*------------------------------------*\
          #Reduction partielle
        \*------------------------------------*/
        if (value.droitEnregistrement === 6 && value.reductionPartielle && value.prix > 0) {
            //On a deja le bon calcul pour celui qui a la reduction dans le droitEnregistrement array
            //On calcul les pourcentage
            let pourcentageReduction = value.montantAcquereurReduction / value.prix;
            let pourcentageAutreAcquereur = value.montantAutreAcquereur / value.prix;
            let labelPourcentageReduction = `${round10(pourcentageReduction * 100, -2)
                .toString()
                .replace(".", ",")}%`;
            let labelPourcentageAutreAcquereur = `${round10(pourcentageAutreAcquereur * 100, -2)
                .toString()
                .replace(".", ",")}%`;

            droitEnregistrementArray = droitEnregistrementArray.map(s => ({
                ...s,
                value: round10(s.value * pourcentageReduction, -2),
                label: `${s.label} (Acquéreur avec réduction, ${labelPourcentageReduction} du bien)`
            }));
            //On ajoute les 12.5% de l'autre type
            droitEnregistrementLabel = `Droits d'enregistrement (12,5%) ${abattementLabel} (Autre acquéreur, ${labelPourcentageAutreAcquereur} du bien)`;
            droitEnregistrement = 0.125 * prixAvecAbattement * pourcentageAutreAcquereur;
            droitEnregistrement = round10(droitEnregistrement, -2);
            /*------------------------------------*\
              #Montant minimum
            \*------------------------------------*/
            if (droitEnregistrement < 50) {
                droitEnregistrement = 50;
            }
            droitEnregistrementArray.push({
                label: droitEnregistrementLabel,
                value: droitEnregistrement,
                etat: true,
                tva: false
            });
        }

        if (value.annexe) {
            droitEnregistrementArray.push({
                label: "Annexe(s)",
                value: 100,
                etat: true,
                tva: false
            });
        }

        let droitEcriture = getSetting("droit_ecriture", settings);

        let eRegistration = getSetting("e_registration", settings);

        let fraisDivers = 0;
        if (value.overrideFraisDivers) {
            fraisDivers = value.fraisDivers;
        } else {
            fraisDivers = getSetting("frais_divers_vente_gre_a_gre_wallonie", settings);
            fraisDivers += value.nombreBiens * getSetting("frais_divers_ajout_par_bien", settings);
        }
        let reduction = [];
        let reductionTva = 0;

        if (value.droitEnregistrement === 5) {
            reduction.push({
                label: "Réduction d'honoraire",
                value: -250,
                etat: false,
                tva: true
            });
            reductionTva = -250;
        }

        let tva = tauxTva * (honoraire + droitEcriture + fraisDivers + eRegistration + reductionTva);

        /*------------------------------------*\
        Round all the shit
    \*------------------------------------*/

        tva = round10(tva, -2);

        let transcription = getSetting("transcription", settings);
        let { nombreBureauxSupplementaires } = value;
        let label = "Transcription";
        let valueTranscription = transcription;
        if (nombreBureauxSupplementaires > 0) {
            label = `Transcription (${value.nombreBureauxSupplementaires} bureau${
                value.nombreBureauxSupplementaires > 1 ? "x" : ""
            } supplémentaire${value.nombreBureauxSupplementaires > 1 ? "s" : ""})`;
            valueTranscription = transcription * (value.nombreBureauxSupplementaires + 1);
        }
        let transcriptionSerie = {
            label,
            value: valueTranscription,
            etat: true,
            tva: false
        };

        var result = [
            ...droitEnregistrementArray,
            transcriptionSerie,
            {
                label: "Honoraire",
                value: honoraire,
                etat: false,
                tva: true
            },
            ...reduction,
            {
                label: "Droits d'écriture",
                value: droitEcriture,
                etat: true,
                tva: true
            },
            {
                label: "E-registration",
                value: eRegistration,
                etat: true,
                tva: true
            },
            {
                label: "Frais divers et recherches",
                value: fraisDivers,
                frais: true,
                tva: true
            },
            {
                label: "TVA",
                value: tva,
                etat: true,
                tva: true
            }
        ];

        /*------------------------------------*\
        #Reduction honoraire après le calcul de la tva
    \*------------------------------------*/

        return {
            typeVisualisation: ETAT_VS_ETUDE,
            series: result
        };
    }
};

export default computationApp;



// WEBPACK FOOTER //
// ./src/computationApps/vente-gre-gre-wallonie.js